
import html2canvas from 'html2canvas'
import { jsPDF as JsPDF } from 'jspdf'
import { bodyswapsLogoDataUrl } from '../assets/Bodyswaps-logo-dataurl'
import { cookies } from '@/util/cookies'

export async function downloadDashboardExportsAsPdf (title, accountName) {
  let successFactorElement, platformUsageElement
  let [platformUsageHeight, successFactorHeight] = [
    document.getElementById('platform-usage-content').offsetHeight,
    document.getElementById('success-factor-content').offsetHeight,
  ]
  // Platform width and Success width should be the same
  const width = document.getElementById('platform-usage-content').offsetWidth
  const defaultWidth = 1000
  const titleHeight = 200

  // Calculate Heights
  if (width < defaultWidth) {
    const ratio = width / defaultWidth
    platformUsageHeight = Math.max(platformUsageHeight / ratio, 100) // Ensure minimum height
    successFactorHeight = Math.max(successFactorHeight / ratio, 100)
  } else {
    const ratio = defaultWidth / width
    platformUsageHeight = Math.max(ratio * platformUsageHeight, 100)
    successFactorHeight = Math.max(ratio * successFactorHeight, 100)
  }

  // Validate dimensions before creating PDF
  const totalHeight = Math.max(successFactorHeight + platformUsageHeight + titleHeight, 300)
  const totalWidth = Math.max(defaultWidth + 200, 400)

  const doc = new JsPDF('portrait', 'mm', [totalHeight, totalWidth])

  // Read html for Platform usage and Success factors and create images
  await html2canvas(document.getElementById('platform-usage-content')).then(canvas => {
    platformUsageElement = canvas.toDataURL('image/jpeg', 1.0)
  })
  await html2canvas(document.getElementById('success-factor-content')).then(canvas => {
    successFactorElement = canvas.toDataURL('image/jpeg', 1.0)
  })

  // Bodyswaps Graphics and titles
  doc.addImage(bodyswapsLogoDataUrl, 'JPEG', 112, 53, 230, 30, 'alias0', 'SLOW')
  doc.setFontSize(40)
  doc.setFont(undefined, 'bold').text(accountName, 112, 120, null, null, 'left')
  doc.setFontSize(35)
  doc.setFont(undefined, 'normal').text(title, 112, 140, null, null, 'left')

  // Platform Usage and Success Factor images
  doc.addImage(platformUsageElement, 'JPEG', 100, 150, 1000, platformUsageHeight, 'alias2', 'SLOW')
  doc.addImage(successFactorElement, 'JPEG', 100, platformUsageHeight + 150, 1000, successFactorHeight, 'alias5', 'SLOW')

  doc.save('Summary of PlatformUsage and success factors.pdf')
}

export function getRegionParam (joiner) {
  const baseUrl = cookies.get('baseUrl')
  const urlToRegionMap = {
    'https://europe-west2-bs-uk-prod.cloudfunctions.net': 'uk',
    'http://127.0.0.1:5001/bs-uk-prod.cloudfunctions.net': 'uk',
    'https://us-central1-bs-us-prod.cloudfunctions.net': 'us',
    'http://127.0.0.1:5001/bs-us-prod.cloudfunctions.net': 'us',
    'https://northamerica-northeast1-bs-ca-prod-ae246.cloudfunctions.net': 'ca',
    'http://127.0.0.1:5001/bs-ca-prod-ae246/northamerica-northeast1': 'ca',
    'https://europe-west2-bodyswaps-experimental.cloudfunctions.net': 'experimental',
    'http://127.0.0.1:5001/bodyswaps-experimental/europe-west2': 'experimental',
    'https://europe-west2-eu-staging-86d4c.cloudfunctions.net': 'staging',
    'http://127.0.0.1:5001/eu-staging-86d4c/europe-west2': 'staging',
  }

  const region = urlToRegionMap[baseUrl]
  return region ? joiner + 'reg=' + region : ''
}
